// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2wc9A","rootMobile":"styles_rootMobile__2Zrve"};